import { ApiErrorResponse } from "../@types";

export const getErrorMessage = (error: any): string => {
  if (error?.data?.exception) {
    return error.data.exception;
  }

  if (error?.data?.messages?.length > 0) {
    return error.data.messages[0];
  }

  if (error?.data?.message) {
    return error.data.message;
  }

  if (error?.message) {
    return error.message;
  }

  return "An unexpected error occurred";
};

export const getAllErrorMessages = (error: any): string[] => {
  if (error?.data?.messages?.length > 0) {
    return error.data.messages;
  }

  if (error?.data?.exception) {
    return [error.data.exception];
  }

  if (error?.data?.message) {
    return [error.data.message];
  }

  if (error?.message) {
    return [error.message];
  }

  return ["An unexpected error occurred"];
};

export const getValidationErrors = (error: any): Record<string, string[]> => {
  return error?.data?.validationErrors || {};
};

export const getErrorDetails = (error: any) => {
  const errorData = error?.data as ApiErrorResponse;

  return {
    message: getErrorMessage(error),
    messages: getAllErrorMessages(error),
    validationErrors: getValidationErrors(error),
    errorId: errorData?.errorId,
    supportMessage: errorData?.supportMessage,
    statusCode: errorData?.statusCode || error?.status,
  };
};

export const isForbiddenError = (error: any): boolean =>
  error?.status === 403 || error?.data?.statusCode === 403;
